import React, { useContext } from 'react';
import BasicDropdownToggle, { BasicDropdownToggleProps as Props } from '../BasicDropdownToggle';
import { PopperDropdownContext } from './PopperDropdownContext';

const PopperDropdownToggle: React.FC<React.PropsWithChildren<Props>> = ({ children, ...props }) => {
  const { setToggleRef } = useContext(PopperDropdownContext);
  return (
    <BasicDropdownToggle {...props} innerRef={setToggleRef}>
      {children}
    </BasicDropdownToggle>
  );
};
PopperDropdownToggle.displayName = 'PopperDropdownToggle';

export default PopperDropdownToggle;
export { type Props };
